import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import DashSplitContainer from "../DashSplitContainer";
import {
  getTransDataFromLs,
  getUserDataFromLs,
  getUserSessionDataFromLs,
} from "../../../../funcs/LSFuncs";
import COLORS from "../../../../constants/Colors";
import InfoGrid from "../../../common/info-grid/InfoGrid";
import dayjs from "dayjs";
import VerifiedIcon from "@mui/icons-material/Verified";
// import URLS from "../../../../assets/strings/URLs";

const AvatarElement = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        mt: "40px",
      }}
    >
      <Box
        sx={{
          height: "80px",
          width: "80px",
          background: COLORS.PRIMARY_GRAD,
          borderRadius: "8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography fontSize={"2rem"} fontWeight={700} color="white">
          {getUserDataFromLs()?.subject?.name?.display[0] || "U"}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          ml: "20px",
          height: "100%",
        }}
      >
        <Typography fontSize={"1.4rem"} fontWeight={600}>
          {getUserDataFromLs()?.subject?.name?.display || "User"}
        </Typography>
        <Typography fontSize={"1rem"} fontWeight={400} sx={{ opacity: "0.5" }}>
          {getUserDataFromLs()?.subject?.designation || "Agent"}
        </Typography>
      </Box>
    </Box>
  );
};

const UserDetails = () => {
  let data = [
    {
      label: "Mobile Number",
      value: getUserDataFromLs()?.subject?.mobile_no || "NA",
    },
    { label: "E-mail", value: getUserDataFromLs()?.subject?.email || "NA" },
    {
      label: "Last logged in",
      value:
        dayjs(getUserSessionDataFromLs()?.loggedInTime).format(
          "D MMM YYYY, hh:mm a"
        ) || "NA",
    },
  ];
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <AvatarElement />
      <Box
        sx={{
          mt: "40px",
        }}
      >
        <InfoGrid margin={0} title="USER INFO" data={data} />
      </Box>
    </Box>
  );
};

const TransporterDetails = () => {
  const transpNameRef = useRef(null);
  const [dynamicMarginTop, setDynamicMarginTop] = useState("-25px");

  useEffect(() => {
    const updateMarginTop = () => {
      if (transpNameRef.current) {
        const transpNameRefTop =
          transpNameRef.current.getBoundingClientRect().top;
        setDynamicMarginTop(`${-1 * (transpNameRefTop - 310)}px`);
      }
    };

    updateMarginTop();
  }, []);

  let data = [
    {
      label: "Owner Name",
      value: getTransDataFromLs()?.owner_name || "NA",
    },
    {
      label: "Home City",
      value: getTransDataFromLs()?.home_city || "NA",
    },
    {
      label: "Operating Cities",
      value: getTransDataFromLs()?.operating_cities.join(", ") || "NA",
    },
    {
      label: "Address",
      value: getTransDataFromLs()?.address || "NA",
    },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "200px",
          // background: `url(${URLS.DEF_PROFILE_COVER || ""})`,
          background: `lightgrey`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          borderRadius: "8px",
        }}
      ></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          ml: "30px",
          mt: dynamicMarginTop,
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            height: "100px",
            width: "100px",
            background: COLORS.TRACKING_GREEN,
            borderRadius: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            outline: "5px white solid",
          }}
        >
          <Typography fontSize={"2rem"} fontWeight={700} color="white">
            {getTransDataFromLs()?.name[0] || "U"}
          </Typography>
        </Box>
        <Typography
          fontSize={"1.5rem"}
          fontWeight={700}
          lineHeight={"2rem"}
          ref={transpNameRef}
        >
          {getTransDataFromLs()?.name || "Transporter"}
          <VerifiedIcon
            sx={{
              color: COLORS.PRIMARY,
              fontSize: "1.8rem",
              mb: "-6px",
              ml: "4px",
            }}
          />
        </Typography>
      </Box>
      <Box
        sx={{
          mt: "40px",
        }}
      >
        <Typography
          fontSize={"1rem"}
          fontWeight={600}
          sx={{
            opacity: 0.3,
          }}
        >
          About
        </Typography>
        <Typography
          fontSize={"1rem"}
          fontWeight={500}
          sx={{
            opacity: 0.9,
          }}
        >
          {getTransDataFromLs()?.profile_desc || "No desc. available"}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: "40px",
        }}
      >
        <InfoGrid margin={0} title="COMPANY INFO" data={data} />
      </Box>
    </Box>
  );
};

const ProfileView = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          height: "calc(100% - 20px)",
          margin: "20px",
        }}
      >
        <TransporterDetails />
      </Box>
      <Box
        sx={{
          width: "2px",
          height: "calc(100% - 20px)",
          background: "grey",
          margin: "10px 0px",
          opacity: 0.1,
        }}
      />
      <Box
        sx={{
          minWidth: "40%",
          height: "calc(100% - 20px)",
          margin: "20px",
        }}
      >
        <UserDetails />
      </Box>
    </Box>
  );
};

function DashProfile() {
  const { setselTab, navToScreen, dashTabs } = useDashLayoutCtx();
  useEffect(() => {
    setselTab(null);
    // eslint-disable-next-line
  }, []);
  return (
    <DashSplitContainer
      heading="Profile"
      actionLabel="Close"
      showAction
      actionFunc={() => navToScreen(dashTabs[0].id)}
    >
      <ProfileView />
    </DashSplitContainer>
  );
}

export default DashProfile;
